export default {
	'.*ABOUT_(DEFAULT|US).*': 'About Us',
	'.*STAFF_LISTING.*': 'About Us',
	'.*INVENTORY_FEATURED_(NEW|USED).*': 'Dealer Specials',
	'.*FINANCE_(APPLICATION|LEAD).*': 'Finance',
	'.*PARTS_LEAD.*': 'Parts',
	'(.*SCHEDULE_SERVICE.*|.*XTIME.*)': 'Schedule Service',
	'.*BODY_?SHOP.*': 'Service',
	'.*SERVICE_(CENTER|LEAD).*': 'Service',
	'.*SPECIALS_LISTING_SERVICE.*': 'Service Specials',
	'.*SHOWROOM.*': 'Showroom',
	'.*TRADE_IN.*': 'Trade In'
};
